import { useState, useEffect } from 'react'

export default function Points() {
  const [records, setRecords] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setRecords([
      { id: 1, childName: '张小明', change: '+100', type: '购买课程', balance: 1200, createdAt: '2026-04-15' },
      { id: 2, childName: '张小明', change: '-50', type: '兑换礼品', balance: 1200, createdAt: '2026-04-10' },
      { id: 3, childName: '李小虎', change: '+200', type: '分享奖励', balance: 800, createdAt: '2026-04-08' },
      { id: 4, childName: '王小虎', change: '+80', type: '完成练习', balance: 300, createdAt: '2026-04-05' },
    ])
    setLoading(false)
  }, [])

  if (loading) return <div style={{ padding: 40 }}>加载中...</div>

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>积分管理</h2>

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>学员</th>
              <th style={th}>变动</th>
              <th style={th}>类型</th>
              <th style={th}>余额</th>
              <th style={th}>时间</th>
            </tr>
          </thead>
          <tbody>
            {records.map(r => (
              <tr key={r.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}>{r.childName}</td>
                <td style={{ ...td, color: r.change.startsWith('+') ? '#1890ff' : '#ff4d4f', fontWeight: 600 }}>{r.change}</td>
                <td style={td}>{r.type}</td>
                <td style={{ ...td, color: '#fa8c16' }}>{r.balance}</td>
                <td style={{ ...td, color: '#999' }}>{r.createdAt}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
